module.exports = __webpack_public_path__ + "img/Aggregation_Akteure.a56d8972.png";